import { searchHistoryApi, SearchHistoryItem } from '../api/searchHistory'

class SearchHistoryService {
  /**
   * 최근 검색어 목록 가져오기 (서버)
   */
  async getSearchHistory(): Promise<SearchHistoryItem[]> {
    try {
      const response = await searchHistoryApi.getList()
      return response.items
    } catch (error) {
      console.error('검색 기록 불러오기 실패:', error)
      return []
    }
  }

  /**
   * 검색어 추가 (서버)
   */
  async addSearchHistory(keyword: string): Promise<void> {
    if (!keyword.trim()) return

    try {
      await searchHistoryApi.add(keyword.trim())
    } catch (error) {
      console.error('검색 기록 저장 실패:', error)
    }
  }

  /**
   * 특정 검색어 삭제 (서버)
   */
  async removeSearchHistory(keyword: string): Promise<void> {
    try {
      await searchHistoryApi.remove(keyword)
    } catch (error) {
      console.error('검색 기록 삭제 실패:', error)
    }
  }

  /**
   * 모든 검색 기록 삭제 (서버)
   */
  async clearSearchHistory(): Promise<void> {
    try {
      await searchHistoryApi.clear()
    } catch (error) {
      console.error('검색 기록 전체 삭제 실패:', error)
    }
  }
}

export const searchHistoryService = new SearchHistoryService()
